"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var social_groups_api_1 = require("@wix/social-groups-api");
exports.group = {
    groupId: 'mocked-group',
    relationship: social_groups_api_1.ApiTypes.v1.RelationshipWithGroup.JOINED,
    details: {
        description: 'Fancy group description',
        title: 'Very popular group title',
    },
    memberCount: 42,
    roles: [social_groups_api_1.ApiTypes.v1.RoleInGroup.GROUP_ADMIN],
    settings: {
        privacyLevel: social_groups_api_1.ApiTypes.v1.GroupPrivacyLevel.PUBLIC,
    },
};
exports.members = [];
exports.currentMember = {
    name: {
        nick: 'Active User',
    },
    roles: [social_groups_api_1.ApiTypes.v1.RoleInGroup.GROUP_MEMBER],
};
//# sourceMappingURL=mocks.js.map